<template>
  <section>
    <fly-schedule-list :query="query" />
  </section>
</template>

<script>
import FlyScheduleList from '@/components/basic/FlyScheduleList'

export default {
  name: 'FlySchedules',
  components: {
    FlyScheduleList
  },

  data() {
    const { query } = this.$route

    return {
      query: query
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (to.name === from.name) {
      this.query = to.query
    }

    next()
  }
}
</script>
